export const isLoadingProfile = state => state.customer.ui.isFetchingProfile;
export const isContactDetailsVisible = state => state.customer.ui.isContactDetailsVisible;